import React, { useEffect } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'

const ReportsModal = ({
  isOpen,
  title,
  onClose,
  onPrev,
  onNext,
  prevDisabled = false,
  nextDisabled = false,
  prevLabel = 'Back',
  nextLabel = 'Next',
  closeLabel = 'Close',
  children
}) => {
  useEffect(() => {
    if (!isOpen) return

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.()
    }

    document.addEventListener('keydown', onKeyDown)

    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.body.style.overflow = prevOverflow
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
      onMouseDown={(e) => {
        // Only close when clicking the backdrop, not when interacting inside the panel
        if (e.target === e.currentTarget) onClose?.()
      }}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div
        className="relative bg-white rounded-lg w-full max-w-5xl max-h-[90vh] overflow-hidden border border-emerald-200"
        style={{
          boxShadow: '0 0 0 1px rgba(16,185,129,0.35), 0 0 32px rgba(16,185,129,0.22)'
        }}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
            aria-label={closeLabel}
          >
            ✕
          </button>
        </div>

        {/* Left/Right navigation arrows */}
        <button
          type="button"
          onClick={onPrev}
          disabled={prevDisabled}
          aria-label={prevLabel}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-11 h-11 rounded-full border border-emerald-200 bg-white/90 text-gray-700 shadow hover:bg-white hover:text-gray-900 disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2"
        >
          <ChevronLeft className="w-5 h-5" strokeWidth={2.5} aria-hidden="true" />
        </button>
        <button
          type="button"
          onClick={onNext}
          disabled={nextDisabled}
          aria-label={nextLabel}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-11 h-11 rounded-full border border-emerald-200 bg-white/90 text-gray-700 shadow hover:bg-white hover:text-gray-900 disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2"
        >
          <ChevronRight className="w-5 h-5" strokeWidth={2.5} aria-hidden="true" />
        </button>

        <div className="px-10 py-6 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  )
}

export default ReportsModal
